/* Spanish catalog mirroring locale-purchases-reports-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'buy.remove': 'Quitar',
  'buy.openPreview': 'Abrir vista previa',
  'buy.noPreview': 'Sin vista previa',
  'buy.savedInBackend': 'El recibo está guardado.',
  'buy.open': 'Abrir',
  'buy.addMoreDocs': 'Añadir más recibos',
  'buy.addMoreDocsHelp': 'Adjunta más recibos o páginas a la misma compra. Aquí se enumeran todos los recibos adjuntos.',
  'buy.uploadDoc': 'Subir recibo',
  'buy.uploadDocHelp': 'Adjunta el recibo o la factura de la compra. Puedes arrastrar un archivo, elegir uno de tu ordenador u obtener un recibo de la Bandeja de entrada.',
  'buy.dropOrPick': 'Suelta o elige un recibo',
  'buy.storedIn': 'El PDF o la imagen se guarda en Firebase/la Bandeja de entrada.',
  'buy.fromInbox': 'Obtener de la Bandeja de entrada',
  'buy.attachments': 'Adjuntos',
  'buy.pickFiles': 'Elegir archivos',
  'buy.dropAttachments': 'Suelta aquí los adjuntos',
  'buy.attachmentsNote': 'Los adjuntos se suben al backend cuando se guarda el registro.',
  'buy.supplierSearch': 'Buscar o añadir un proveedor...',
  'buy.supplierSearchShort': 'Buscar o añadir un proveedor',
  'buy.supplierClose': 'Cerrar la selección de proveedor',
  'buy.supplierNone': 'No se encontraron proveedores.',
  'buy.supplierNew': 'Nuevo proveedor',
  'buy.name': 'Nombre',
  'buy.org': 'N.º de empresa',
  'buy.email': 'Correo electrónico',
  'buy.phone': 'Teléfono',
  'buy.accountClose': 'Cerrar la selección de cuenta',
  'buy.searchShort': 'Buscar ...',
  'buy.noAccountMatch': 'Ninguna cuenta coincide con la búsqueda.',
  'buy.fromInboxRead': 'Obtenido de la Bandeja de entrada: SuperPlumma leyó lo que pudo.',
  'buy.docHelp': 'El recibo es el ticket de caja o la factura que documenta la compra. Arrastra una imagen o un PDF, o toca para elegir un archivo. SuperPlumma lee la fecha, el importe, el proveedor y el IVA, y sugiere cómo contabilizar la compra.',
  'buy.dropReceipt': 'Suelta aquí el recibo',
  'buy.dropReceiptHelp': 'Obtén el recibo de tus archivos o elige «Obtener de la Bandeja de entrada» para usar un recibo que ya llegó por correo electrónico. SuperPlumma lee el contenido automáticamente.',
  'buy.upload': 'Subir',
  'buy.type': 'Tipo de compra',
  'buy.typeHelp': 'Elige cómo se debe registrar la compra. «Compra pagada» es una compra que ya se ha pagado. «Factura de proveedor» se usa cuando la factura se pagará más tarde o se ha pagado en parte (pasa a cuentas por pagar). «Borradores» muestra las compras que has empezado pero aún no has contabilizado.',
  'buy.description': 'Descripción',
  'buy.descriptionPh': 'Ej.: suscripción o viaje',
  'buy.toggleVat': 'Cambiar entre sin IVA y con IVA',
  'buy.amountExInc': 'Importe sin/con IVA',
  'buy.amountExIncHelp': 'Toca para cambiar si introduces el importe sin IVA (neto) o con IVA (bruto). Plumme convierte entre ambos automáticamente. «Sin IVA» es el coste en sí; «con IVA» es el total que pagaste.',
  'buy.vatRate': 'Tipo de IVA',
  'buy.vatRateHelp': 'El tipo de IVA de la compra. El 25 % es el tipo general, el 15 % se aplica a los alimentos, el 12 % se aplica, entre otros, al transporte de pasajeros y al alojamiento, y el 0 % se usa para compras exentas. El IVA de una compra es IVA soportado, que puedes deducir.',
  'buy.pickCategory': 'Cuenta/categoría',
  'buy.category': 'Categoría',
  'buy.categoryHelp': 'Qué tipo de gasto es. La categoría decide en qué cuenta se contabiliza la compra, de modo que aparezca correctamente en la cuenta de resultados y en la declaración de impuestos.',
  'buy.supplier': 'Proveedor',
  'buy.accountFromHistory': 'Cuenta de gasto sugerida a partir de compras anteriores con este proveedor. Puedes cambiarla en la línea de compra.',
  'buy.date': 'Fecha de compra',
  'buy.invoiceNumber': 'Número de factura',
  'buy.invoiceNumberPh': 'Ej.: 100245',
  'buy.dueDate': 'Fecha de vencimiento',
  'buy.lines': 'Líneas',
  'buy.linesHelp': 'Cada línea es un gasto del recibo, con su propio importe, tipo de IVA y categoría. Si el recibo tiene varios artículos o tipos de IVA distintos, crea una línea por cada tipo. Puedes arrastrar las líneas para reordenarlas.',
  'buy.addLine': 'Añadir línea',
  'buy.payment': 'Pago',
  'buy.paymentHelp': 'En una factura de proveedor, elige si la factura se ha pagado. Las facturas pendientes se guardan como cuentas por pagar abiertas para poder registrar el pago más tarde.',
  'buy.immediatePaymentHelp': 'Una compra normal ya se ha pagado. Elige la cuenta desde la que se pagó y la fecha de pago.',
  'buy.paid': 'Pagada',
  'buy.unpaid': 'Pendiente de pago',
  'buy.paidFrom': 'Pagada desde',
  'buy.choosePaymentSource': 'Elige el origen del pago',
  'buy.paidDate': 'Fecha de pago',
  'buy.paidDateHelp': 'La fecha en que se pagó la compra. La fecha de compra determina el periodo contable y de IVA de la propia compra.',
  'buy.dateLabel': 'Fecha',
  'buy.addPartPayment': 'Añadir pago parcial',
  'buy.addPartPaymentHelp': 'Registra otro pago. La suma de los pagos parciales se resta del total; lo que queda se muestra como «pendiente».',
  'buy.remaining': 'Pendiente',
  'buy.remainingHelp': 'La diferencia entre el total y lo que has registrado como pagos parciales. Si es 0, la compra está totalmente liquidada.',
  'buy.preview': 'Vista previa',
  'buy.previewHelp': 'Una vista previa del recibo que has subido. Si no has subido ninguno, puedes hacerlo aquí.',
  'buy.dropReceiptLong': 'Suelta aquí el recibo: arrastra una imagen o un PDF, o toca para elegir un archivo.',
  'buy.summaryHelp': 'El resumen muestra el neto, el IVA y el total que pagas.',
  'buy.saveDraft': 'Guardar borrador',
  'buy.saveDraftHelp': 'Guarda la compra como borrador sin contabilizarla. Los recibos y los pagos no se marcan como contabilizados hasta que completes la compra.',
  'buy.title': 'Compra pagada',
  'buy.subtitle': 'Registra una compra: sube el recibo y nosotros sugerimos el resto.',
  'buy.drafts': 'Borradores',
  'buy.draftsSub': 'Compras y activos que has empezado pero aún no has contabilizado',
  'buy.draftsSearchPh': 'Proveedor, descripción, n.º de factura o importe',
  'buy.showMore': 'Mostrar más',
  'buy.noDrafts': 'No hay borradores',
  'buy.invoiceNoShort': 'N.º de factura',
  'buy.delete': 'Eliminar',
  'buy.deleteDraftTitle': '¿Eliminar el borrador?',
  'buy.deleteDraftConfirm': 'Sí, eliminar el borrador',
  'buy.deleteDraftBody': '¿Seguro que quieres eliminar el borrador de',
  'buy.resetTitle': 'Vaciar el formulario y empezar de nuevo',
  'buy.reset': 'Vaciar',
  'buy.howRegister': '¿Cómo quieres registrar la compra?',
  'buy.howRegisterSub': 'Puedes subir primero el recibo y nosotros sugerimos el resto.',
  'buy.stepByStep': 'Paso a paso',
  'buy.stepByStepHelp': 'Te guía por la compra parte por parte: primero el recibo, luego la fecha, las líneas y el pago. Útil cuando prefieres ir con calma.',
  'buy.stepByStepShort': 'Primero el recibo, luego la fecha, las líneas y el pago.',
  'buy.onePage': 'Todo en una página',
  'buy.onePageHelp': 'Muestra todo el formulario de compra en una sola página. Útil cuando ya estás acostumbrado a registrar compras y quieres verlo todo delante.',
  'buy.onePageShort': 'Todo el formulario de compra junto.',
  'buy.toSteps': 'Cambiar a paso a paso',
  'buy.toOnePage': 'Cambiar a todo en una página',
  'buy.back': 'Atrás',
  'buy.next': 'Siguiente',
  'buy.backToVouchers': 'Volver a los movimientos',
  'buy.salesType': 'Tipo de venta',
  'buy.paidTo': 'Pagado a',
  'buy.payOperating': 'Cuenta operativa',
  'buy.payCash': 'Efectivo',
  'buy.payPrivate': 'Privado',
  'buy.whatSold': '¿Qué has vendido?',
  'buy.amountExVat': 'Importe sin IVA',
  'buy.amountIncVat': 'Importe con IVA',
  'buy.vatLabel': 'IVA',
  'buy.otherSale': 'Otra venta',
  'buy.invoiceOrQuote': 'Factura / presupuesto',
  'buy.switchMode': 'Cambiar de modo',
  'buy.moreOptions': 'Más opciones',
  'buy.postAs': 'Contabilizar como',
  'buy.backendUploadNotReady': 'La subida al backend no está lista.',
  'buy.multipleUploadedShowFirst': 'Se subieron varios recibos. Aquí se muestra el primero.',
  'buy.uploadFailed': 'No se pudo subir el recibo.',
  'buy.dropReceiptTitle': 'Suelta aquí el recibo',
  'buy.dropReceiptSubtitle': '...y te ayudamos a ubicarlo correctamente. Arrastra una imagen o un PDF, o toca para elegir un archivo.',
  'buy.attachedCount': '{count} recibos vinculados',
  'buy.uploading': 'Subiendo...',
  'buy.chooseFile': 'Elegir archivo',
  'buy.dropToUpload': 'Suelta el recibo para subirlo',
  'buy.accountFallbackOperating': 'Cuenta operativa · 1920',
  'buy.accountFallbackCash': 'Efectivo',
  'buy.accountFallbackPrivate': 'Gasto privado',
  'buy.accountFallbackCash1900': 'Efectivo - 1900',
  'buy.accountFallbackPrivate2060': 'Privado - 2060',
  'buy.addSupplierQuery': 'Añadir «{query}»',
  'buy.chartNotConnected': 'El plan de cuentas no está conectado al almacenamiento.',
  'buy.accountAdded': 'La cuenta se ha añadido.',
  'buy.accountSaveFailed': 'No se pudo guardar la cuenta.',
  'buy.chooseAccount': 'Elegir cuenta',
  'buy.forQuery': 'para «{query}»',
  'buy.newCustomAccountTitle': 'Nueva cuenta personalizada',
  'buy.saving': 'Guardando...',
  'buy.saveAccount': 'Guardar cuenta',
  'buy.accountNamePlaceholder': 'Ej.: Desarrollo de software',
  'buy.accountHelperText': 'La cuenta queda disponible en la búsqueda de cuentas y se asigna a la cuenta estándar para los informes y el cierre anual.',
  'buy.inventoryProduct': 'Artículo de inventario',
  'buy.notTracked': 'Sin control de existencias',
  'buy.quantityInStock': 'Cantidad añadida al inventario',
  'buy.inStockCount': '{n} en existencias',
  'buy.inventoryLineToggle': 'Actualizar el inventario con esta línea',
  'buy.inventoryLineToggleHelp': 'Actívalo cuando la compra deba aumentar la cantidad de un artículo de inventario registrado.',
  'buy.inventorySearchPlaceholder': 'Elegir artículo de inventario',
  'buy.inventorySearch': 'Buscar por nombre, número de artículo, SKU o EAN',
  'buy.inventorySearchEmpty': 'Ningún artículo con control de existencias coincide con la búsqueda.',
  'buy.inventoryOpenProducts': 'Abrir productos',
  'buy.inventoryUnitsInStock': 'en existencias',
  'inventoryPurchase.settingsTitle': 'Inventario en las compras',
  'inventoryPurchase.settingsHelp': 'Muestra un control de inventario opcional en las líneas de compra para que una compra pueda aumentar la cantidad de un artículo de inventario registrado.',
  'inventoryPurchase.offHelp': 'El control de inventario está oculto en las compras nuevas. Los productos y los movimientos de inventario anteriores se conservan.',
  'inventoryPurchase.migratedTitle': 'Se ha activado el inventario en las compras',
  'inventoryPurchase.migratedText': 'Esta empresa ya tiene productos con control automático de inventario. Se activó la vinculación de inventario en las líneas de compra para que el flujo existente pueda continuar.',
  'inventoryPurchase.acknowledge': 'Entendido',
  'inventoryPurchase.acknowledgeError': 'No se pudo guardar la confirmación.',
  'inventoryPurchase.openSettings': 'Abrir ajustes',
  'inventoryPurchase.disableTitle': '¿Desactivar el inventario en las compras?',
  'inventoryPurchase.disableConfirm': 'Desactivar',
  'inventoryPurchase.disableWarning': 'El control de inventario se ocultará en las compras nuevas. Las compras ya no se podrán vincular a productos con control de existencias, y las cantidades pueden quedar incorrectas si no se comprueban y ajustan manualmente.',
  'inventoryPurchase.disableHistory': 'Los productos existentes y los movimientos de inventario históricos no se eliminan. Cuenta el inventario y registra manualmente los ajustes necesarios.',
  'inventoryPurchase.enabledLabel': 'Inventario en las compras',
  'inventoryPurchase.disabledLabel': 'Inventario en las compras',
  'buy.noDescription': 'Sin descripción',
  'buy.attachmentFallback': 'Recibo',
  'buy.lockVatTitle': 'El periodo de la declaración de IVA ya se ha presentado',
  'buy.lockYearTitle': 'El ejercicio fiscal está cerrado',
  'buy.lockBankTitle': 'El periodo bancario está conciliado',
  'buy.lockVatTarget': 'el periodo de la declaración de IVA',
  'buy.lockYearTarget': 'el cierre anual',
  'buy.lockBankTarget': 'la conciliación bancaria',
  'buy.lockWarningText': '{title}. Aún puedes cambiar la descripción y la cuenta/categoría de gasto de la compra, pero la fecha de compra, el importe, el código de IVA y los campos de pago están bloqueados. Abre o corrige {target} si necesitas cambiar estos campos.',
  'buy.lockVatWarningText': '{title}. La fecha de compra, el importe y el código de IVA están bloqueados, pero la descripción, la cuenta/categoría de gasto y la cuenta de pago aún se pueden corregir. Abre o corrige {target} si la base del IVA debe cambiar.',
  'buy.backendSaveNotReady': 'El guardado en el backend no está listo.',
  'buy.needAtLeastOneLine': 'Añade al menos una línea de compra.',
  'buy.needDescriptionAllLines': 'Introduce una descripción en todas las líneas antes de contabilizar.',
  'buy.needContentForDraft': 'Añade una línea, un proveedor o un recibo antes de guardar el borrador.',
  'buy.needSupplierForInvoice': 'Elige un proveedor o introduce su nombre antes de guardar un pago parcial/factura de proveedor.',
  'buy.draftSaved': 'Borrador guardado.',
  'buy.attachmentUpdated': 'El recibo se ha actualizado.',
  'buy.invoiceRegisteredOpen': 'Factura registrada como factura de proveedor abierta.',
  'buy.purchaseBooked': '¡Compra contabilizada! El recibo ya está en Movimientos.',
  'buy.purchaseSaveFailed': 'No se pudo guardar la compra.',
  'buy.docsFetchedFromInbox': '{count} recibos obtenidos de la Bandeja de entrada',
  'buy.fullPayment': 'Pago completo',
  'buy.partPayment': 'Pago parcial',
  'buy.partPaymentWarning': 'Un pago parcial se registra como factura de proveedor. El resto se contabiliza como cuentas por pagar en 2400 hasta que se pague.',
  'buy.partPaymentLabel': 'Pago parcial {n}',
  'buy.remainingSuffix': '· pendiente',
  'buy.unpaidWillBeInvoice': 'Sin un pago registrado, se guarda como factura de proveedor abierta. Puedes registrar el pago más tarde.',
  'buy.forgotReceiptTitle': '¿Olvidaste el recibo?',
  'buy.registerInvoice': 'Registrar factura',
  'buy.bookPurchase': 'Contabilizar compra',
  'buy.registerInvoiceHelp': 'Guarda la factura como cuenta por pagar abierta. Aparece bajo el proveedor y registras el pago cuando se haya pagado.',
  'buy.bookPurchaseHelp': 'Guarda la compra en la contabilidad. El recibo queda en «Movimientos» y los importes se contabilizan en las cuentas correctas.',
  'buy.typeBadgeInvoice': 'Factura',
  'buy.typeBadgeAsset': 'Activo',
  'buy.draftDeleteNotConnected': 'La eliminación de borradores no está conectada al backend.',
  'buy.draftDeleted': 'Borrador eliminado.',
  'buy.draftDeleteFailed': 'No se pudo eliminar el borrador.',
  'buy.pageHelpDrafts': 'Aquí registras todo lo que compra la empresa. Elige «Borradores» en el menú desplegable para ver las compras que has empezado pero aún no has contabilizado.',
  'buy.draftsPageHelp': 'Las compras que has empezado pero no has completado se guardan aquí. Abre un borrador para continuar o elimina los que no necesites.',
  'buy.viewOptionsLabel': 'Opciones de visualización',
  'buy.assetsLabel': 'Activos',
  'buy.noDraftsMatchSearch': 'Ningún borrador coincide con la búsqueda.',
  'buy.draftsEmptyHint': 'Las compras que has empezado y guardas como borrador aparecen aquí.',
  'buy.colSupplier': 'Proveedor',
  'buy.noSupplier': 'Sin proveedor',
  'buy.colType': 'Tipo',
  'buy.colInvoiceNo': 'N.º de factura',
  'buy.colDate': 'Fecha',
  'buy.colAmount': 'Importe',
  'buy.thisPurchaseFallback': 'esta compra',
  'buy.cannotBeUndone': '? Esta acción no se puede deshacer.',
  'buy.formReset': 'El formulario se ha restablecido',
  'buy.editPurchaseSubtitle': 'Actualiza el recibo y guarda los cambios en el backend.',
  'buy.newPurchasePageHelp': 'Aquí registras todo lo que compra la empresa: mercancías, equipos, suscripciones, viajes. Sube el recibo y SuperPlumma lee los detalles y contabiliza el gasto en la cuenta correcta con el IVA correcto.',
  'buy.defaultLineDescription': 'Compra',
  'buy.customerFallback': 'Cliente',
  'buy.supplierAndDateTitle': 'Proveedor y fecha',
  'buy.supplierAndDateInvoiceHelp': 'A quién compraste y cuándo. La fecha de factura es la que figura en la factura, y la fecha de vencimiento es cuándo debe pagarse. El número de factura es el número propio del proveedor en la factura.',
  'buy.supplierAndDatePurchaseHelp': 'La fecha de compra determina en qué periodo contable y de IVA cae la compra. Usa la fecha del recibo.',
  'buy.katFixedAssets': 'Activos fijos / equipos',
  'buy.katRent': 'Alquiler',
  'buy.katPhoneInternet': 'Teléfono e internet',
  'buy.katSoftware': 'Software / suscripción',
  'buy.katTravel': 'Viajes y dietas',
  'buy.katRepresentation': 'Gastos de representación',
  'buy.acct4000': 'Materias primas y productos semielaborados',
  'buy.acct4300': 'Compras de mercancías para reventa',
  'buy.acct4500': 'Servicios externos y subcontratistas',
  'buy.acct5000': 'Salarios de empleados',
  'buy.acct5400': 'Cotizaciones sociales del empleador',
  'buy.acct5900': 'Regalos a empleados',
  'buy.acct6000': 'Amortización',
  'buy.acct6100': 'Gastos de flete y transporte',
  'buy.acct6200': 'Energía, electricidad y calefacción',
  'buy.acct6300': 'Alquiler de locales',
  'buy.acct6320': 'Recogida de residuos, agua, alcantarillado, etc.',
  'buy.acct6340': 'Iluminación, calefacción',
  'buy.acct6360': 'Limpieza',
  'buy.acct6400': 'Alquiler de maquinaria',
  'buy.acct6500': 'Herramientas y utillaje',
  'buy.acct6540': 'Mobiliario y equipos',
  'buy.acct6550': 'Material de operación',
  'buy.acct6560': 'Suministros',
  'buy.acct6600': 'Reparación y mantenimiento de edificios',
  'buy.acct6690': 'Reparación y mantenimiento, otros',
  'buy.acct6700': 'Auditoría y contabilidad',
  'buy.acct6720': 'Asistencia jurídica',
  'buy.acct6790': 'Otros servicios contratados',
  'buy.acct6800': 'Material de oficina',
  'buy.acct6810': 'Gastos informáticos',
  'buy.acct6820': 'Material impreso',
  'buy.acct6900': 'Teléfono',
  'buy.acct6940': 'Franqueo',
  'buy.acct7000': 'Combustible de vehículos',
  'buy.acct7020': 'Mantenimiento de vehículos',
  'buy.acct7040': 'Seguro y tasas de vehículos',
  'buy.acct7100': 'Indemnización por kilometraje',
  'buy.acct7140': 'Gastos de viaje no declarables',
  'buy.acct7150': 'Gastos de dietas',
  'buy.acct7160': 'Gastos de viaje declarables',
  'buy.acct7300': 'Gastos de venta',
  'buy.acct7320': 'Publicidad',
  'buy.acct7350': 'Gastos de representación deducibles',
  'buy.acct7360': 'Gastos de representación no deducibles',
  'buy.acct7400': 'Cuotas de asociación',
  'buy.acct7500': 'Prima de seguro',
  'buy.acct7600': 'Licencias, patentes y regalías',
  'buy.acct7700': 'Otros gastos de explotación',
  'buy.acct7770': 'Comisiones bancarias y de tarjeta',
  'buy.acct7790': 'Otros costes',
  'buy.acct8050': 'Ingresos por intereses',
  'buy.acct8150': 'Gastos por intereses',
  'buy.acct8300': 'Impuesto a pagar',
  'buy.fallbackCostName': 'Coste',
  'buy.fallbackAccountName': 'Cuenta',
  'buy.grp40': 'Coste de mercancías',
  'buy.grp43': 'Mercancías para reventa',
  'buy.grp45': 'Servicios contratados',
  'buy.grp50': 'Salarios',
  'buy.grp54': 'Cotización del empleador',
  'buy.grp59': 'Gastos de personal',
  'buy.grp60': 'Amortización',
  'buy.grp61': 'Flete y transporte',
  'buy.grp62': 'Energía y calefacción',
  'buy.grp63': 'Locales',
  'buy.grp64': 'Alquiler de maquinaria y equipos',
  'buy.grp65': 'Herramientas y utillaje',
  'buy.grp66': 'Reparación y mantenimiento',
  'buy.grp67': 'Servicios contratados',
  'buy.grp68': 'Gastos de oficina',
  'buy.grp69': 'Teléfono, franqueo, etc.',
  'buy.grp70': 'Vehículos',
  'buy.grp71': 'Viajes y dietas',
  'buy.grp73': 'Ventas y representación',
  'buy.grp74': 'Cuotas de asociación',
  'buy.grp75': 'Seguros',
  'buy.grp76': 'Licencias y regalías',
  'buy.grp77': 'Otros gastos de explotación',
  'buy.grp15': 'Cuentas por cobrar',
  'buy.grp24': 'Cuentas por pagar',
  'buy.groupAssets': 'Activos',
  'buy.groupEquityAndLiabilities': 'Patrimonio y pasivos',
  'buy.groupIncome': 'Ingresos',
  'buy.groupCostOfGoods': 'Coste de mercancías',
  'buy.groupPayrollAndPersonnel': 'Nómina y gastos de personal',
  'buy.groupOtherOperating': 'Otros gastos de explotación',
  'buy.groupFinanceAndTax': 'Finanzas e impuestos',
  'buy.groupAccountsFallback': 'Cuentas',
  'rep.trial.onlyMovement': 'Mostrar solo cuentas con movimiento',
  'rep.trial.showInactive': 'Mostrar también las cuentas inactivas',
  'rep.trial.payrollLiability': 'Nómina por pagar',
  'rep.trial.holidayPayLiability': 'Vacaciones pagadas por pagar',
  'rep.trial.oneEmployee': '{n} empleado',
  'rep.trial.employeeCount': '{n} empleados',
  'rep.trial.otherPayrollLiability': 'Todos los asientos de 2930',
  'rep.trial.allAccountEntries': 'Todos los asientos de {account}',
  'rep.trial.payrollRun': 'Ejecución de nómina {period}',
  'rep.trial.term': 'Periodo {term}, {year}',
  'rep.trial.accrualYear': 'Ejercicio de devengo {year}',
  'vehiclePolicy.dialogTitle': 'Vehículo y costes del vehículo',
  'vehiclePolicy.intro': 'Elige cómo debe tratar Plumme el combustible, el taller y otros costes claros del vehículo. Es un ajuste de flujo de trabajo para las sugerencias de recibos y no registra un vehículo como activo.',
  'vehiclePolicy.optionVat': 'Vehículo con deducción de IVA',
  'vehiclePolicy.optionVatSub': 'La empresa es propietaria del vehículo o lo tiene en alquiler, el tipo de vehículo cumple los requisitos y el coste se relaciona con una actividad sujeta a IVA registrada.',
  'vehiclePolicy.optionNoVat': 'Vehículo sin deducción de IVA',
  'vehiclePolicy.optionNoVatSub': 'Sugerir el coste del vehículo sin deducción de IVA soportado.',
  'vehiclePolicy.optionManual': 'Revisar cada recibo manualmente',
  'vehiclePolicy.optionManualSub': 'Plumme sugiere la cuenta, pero deja la deducción de IVA para revisión.',
  'vehiclePolicy.validFrom': 'En vigor desde',
  'vehiclePolicy.noEndDateWarning': 'Sin fecha de fin, la elección sigue activa hasta que la cambies. Una nueva elección finaliza automáticamente la anterior desde la fecha del cambio.',
  'vehiclePolicy.responsibility': 'Confirmo que esta información es correcta y entiendo que debo actualizarla si se vende el vehículo, termina el alquiler o cambia el tipo o el uso del vehículo.',
  'vehiclePolicy.receiptTitle': 'Confirma el vehículo una sola vez',
  'vehiclePolicy.receiptText': 'Así, los recibos posteriores de combustible y taller podrán recibir automáticamente la sugerencia de IVA correcta.',
  'vehiclePolicy.changeFromReceiptTitle': '¿Actualizar la regla del vehículo?',
  'vehiclePolicy.changeFromReceiptText': 'Cambiaste este recibo de vehículo a una deducción de IVA del 0 %. ¿Debe aplicarse solo a este recibo, o debe Plumme tratar de ahora en adelante los costes del vehículo sin deducción de IVA porque el vehículo se vendió, terminó el alquiler o ya no se aplica el derecho a deducción?',
  'vehiclePolicy.changeFromReceiptDate': 'La nueva regla se aplicará desde {date}.',
  'vehiclePolicy.receiptOnly': 'Solo este recibo',
  'vehiclePolicy.updateToNoVat': 'Usar 0 % de ahora en adelante',
  'vehiclePolicy.settingsTitle': 'Vehículo y costes del vehículo',
  'vehiclePolicy.settingsText': 'Controla las sugerencias automáticas para combustible, taller y otros costes claros del vehículo. Este ajuste no contabiliza asientos ni crea un activo o un alquiler.',
  'vehiclePolicy.choose': 'Elegir ajuste',
  'vehiclePolicy.change': 'Cambiar ajuste',
  'vehiclePolicy.save': 'Guardar y aplicar',
  'vehiclePolicy.saved': 'El ajuste del vehículo se ha guardado.',
  'vehiclePolicy.saveError': 'No se pudo guardar el ajuste del vehículo.',
  'vehiclePolicy.chooseError': 'Elige cómo se deben tratar los recibos del vehículo.',
  'vehiclePolicy.confirmError': 'Confirma que la empresa mantendrá esta información actualizada.',
  'vehiclePolicy.notConfigured': 'Sin configurar: los recibos del vehículo requieren revisión',
  'vehiclePolicy.activeFrom': 'En vigor desde',
  'vehiclePolicy.noEndDate': 'sin fecha de fin',
  'vehiclePolicy.mode.vat_deductible': 'Vehículo con deducción de IVA',
  'vehiclePolicy.mode.no_vat_deduction': 'Vehículo sin deducción de IVA',
  'vehiclePolicy.mode.manual_review': 'Revisión manual de cada recibo',
  'buy.vatDeduction': 'Deducción del IVA soportado',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Parcial',
  'buy.vatDeductionPercent': 'Porcentaje de deducción',
  'buy.fixedAssetLine': 'Registrar esta línea como activo fijo',
  'buy.fixedAssetLineHelp': 'La línea se añade al registro de activos fijos en lugar de tratarse solo como un gasto.',
  'buy.fixedAssetFallback': 'Activo fijo',
  'buy.projectForLine': 'Proyecto de esta línea',
  'sup.credit.created': 'La nota de crédito del proveedor se ha contabilizado.',
  'sup.credit.refunded': 'El reembolso se ha contabilizado.',
  'sup.credit.title': 'Registrar nota de crédito del proveedor',
  'sup.credit.refundTitle': 'Registrar reembolso de nota de crédito',
  'sup.credit.action': 'Contabilizar nota de crédito',
  'sup.credit.refundAction': 'Registrar reembolso',
});
